/**
 * Centralized sessionStorage key factories.
 * Import from here instead of writing key strings inline to prevent drift.
 */
export const sessionKeys = {
  tiktokIndexed:    (id: string) => `tiktok_session_indexed_${id}`,
  youtubeIndexed:   (id: string) => `youtube_session_indexed_${id}`,
  igIndexed:        (id: string) => `ig_session_indexed_${id}`,
  tiktokConnecting: 'tiktok_connecting',
  youtubeConnecting: 'youtube_connecting',
} as const;
